import { Button, Paper, SegmentedControl, Stack, Text, TextInput, Title } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useAuth } from "../../context/useAuth";
import { adminApi } from "../../lib/api";
import { DeleteAccountCard } from "../../components/profile/DeleteAccountCard";
import { ApiError } from "../../lib/apiClient";

export function AdminProfilePage() {
  const { user } = useAuth();
  const [cadence, setCadence] = useState<"daily" | "weekly">("daily");

  const runDigestMutation = useMutation({
    mutationFn: () => adminApi.runDigest(cadence),
    onSuccess: (result) => {
      notifications.show({
        color: result.users_sent ? "green" : "yellow",
        title: result.users_sent ? "Digests sent" : "Nothing to send",
        message: result.message,
      });
    },
    onError: (err) => {
      const message = err instanceof ApiError ? err.message : "Something went wrong";
      notifications.show({ color: "red", title: "Digest run failed", message });
    },
  });

  return (
    <Stack gap="lg" maw="var(--axio-unit-640)">
      <div>
        <Title order={2}>Admin profile</Title>
        <Text c="dimmed">Account details and notification tools.</Text>
      </div>

      <Paper withBorder p="lg">
        <Stack gap="md">
          <TextInput label="Full name" value={user?.full_name ?? ""} disabled />
          <TextInput label="Email" value={user?.email ?? ""} disabled />
        </Stack>
      </Paper>

      <Paper withBorder p="lg">
        <Title order={4} mb="xs">
          Send notification digests
        </Title>
        <Text size="sm" c="dimmed" mb="md">
          Runs the same job as the scheduled cron: one summary email per user on{" "}
          <strong>Summary</strong> frequency with pending notifications. Only verified emails
          receive mail.
        </Text>

        <SegmentedControl
          value={cadence}
          onChange={(value) => setCadence(value as "daily" | "weekly")}
          data={[
            { label: "Daily summary users", value: "daily" },
            { label: "Weekly summary users", value: "weekly" },
          ]}
          mb="md"
        />

        <Button
          color="violet"
          loading={runDigestMutation.isPending}
          onClick={() => runDigestMutation.mutate()}
        >
          Send digests to all users now
        </Button>
      </Paper>
      <DeleteAccountCard />
    </Stack>
  );
}
